import { Button, Stack, Typography } from '@mui/material'
import React from 'react'

import { GremlinLogo } from 'components/common/GremlinLogo'
import Icon from 'components/Icon'
import useAuth from 'hooks/use-auth'
import { track } from 'track'
import { formatDate } from 'utils/formatDate'

export const CompanyDashboardHeader: React.FC<{
  isDashboardLoading: boolean
}> = ({ isDashboardLoading }) => {
  const { companyDisplayName } = useAuth()

  const handlePrintDashboard = () => {
    const currentDocumentTitle = document.title

    // Adds an event listener to change the document title prior to printing.
    // The "once" option is set to "true" so that this listener is removed after invocation.
    addEventListener(
      'beforeprint',
      () => {
        document.title = `${companyDisplayName}-dashboard-${formatDate(
          new Date()
        )}`
      },
      { once: true }
    )

    // Adds an event listener to revert the document title after printing.
    // The "once" option is set to "true" so that this listener is removed after invocation.
    addEventListener(
      'afterprint',
      () => {
        document.title = currentDocumentTitle
      },
      { once: true }
    )

    // Track event usage for Segment metrics
    track('PrintRMCompanyDashboard')

    window.print()
  }

  return (
    <>
      <GremlinLogo
        css={{
          display: 'none'
        }}
        id="CompanyDashboardReportGremlinLogo"
      />
      <Stack direction="row" gap={2}>
        <Typography data-test-company-dashboard-header-text variant="h5">
          Company Dashboard
        </Typography>
        <Button
          data-test-company-dashboard-export-button
          disabled={isDashboardLoading}
          id="CompanyDashboardReportExportButton"
          startIcon={<Icon icon="solidDownload" />}
          variant="contained"
          onClick={handlePrintDashboard}
        >
          Export
        </Button>
      </Stack>
    </>
  )
}
